document.addEventListener('click', async (event) => {
  // ✅ Skip anchor links like "See Options"
  if (event.target.closest('a.variant-btn')) {
    return;
  }

  // Handle variant button
  const button = event.target.closest('.variant-btn');
  if (!button || !button.closest('.quick-variant-buttons')) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return; // ✅ Prevent trying to add invalid variants

  const res = await fetch(window.theme.routes.cartAdd, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  });

  if (!res.ok) {
    alert('Error adding to cart');
    return;
  }

  const cartType = window.theme.settings.cartType;
  const afterAdd = window.theme.settings.afterAddToCart;

  if (cartType === 'drawer' && afterAdd === 'drawer') {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
  } else {
    window.location.href = window.theme.routes.cart;
  }
});
